import React from 'react';
import clsx from 'clsx';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';

import TimeFormat from '@/components/TimeFormat';
import Logo from '@/components/Logo';
import TwoTone from '@/components/TwoTone';
import Score from '@/components/Score';


const useStyles = makeStyles(() => ({
  block: {
    display: 'block',
  },
  container: {
    padding: 10,
  },
  marginRight: {
    marginRight: 5,
  },
}))

function GoalInfo({ goal, players, teams }) {
  const classes = useStyles();
  const { result } = goal;

  // Gets the player name from the ID
  function getPlayerName(id){
    return players[id].name;
  }

  return (
    <Grid container spacing={1} className={classes.container}>
      <Grid container item xs={12} alignItems="center" spacing={1}>
        <Grid item xs={3}>
          <Logo id={teams[result.team].id} />
        </Grid>
        <Grid container item xs>
          <Grid item xs={12}>
            <Typography variant="h6" component="p">
            {getPlayerName(result.player.id)} ({result.player.total}) {result.variant !== "EV" && `(${result.variant})`}
            </Typography>
          </Grid>
          <Grid item xs={12} className={classes.section}>
            {result.assists.length ? result.assists.map((assist, idx) => (
                <Typography key={assist.id} variant="caption" className={clsx({ [classes.marginRight]: idx === 0 })}>
                  {getPlayerName(assist.id)} ({assist.total})
                </Typography>
              )) : <Typography variant="caption">Unassisted</Typography>
            }
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs={12}>
        <TwoTone
          renderLeft={
            <Typography variant="caption">
              <TimeFormat time={goal.second} /> / {goal.period}
            </Typography>
          }
          renderRight={<Score teams={teams} scoringTeam={result.team} score={result.score} />}
        />
      </Grid>
    </Grid>
  )
}

export default GoalInfo;
